(function (window, document) {
    let collapse = document?.getElementsByClassName('collapsable')[1];
    let collapseLegend = collapse?.parentElement?.children[0];

    collapse?.classList?.add("hide-collapse");
    collapseLegend?.classList?.add("toggle-collapse");
    collapseLegend.classList.add("plus-icon");
    collapseLegend.parentElement.style.marginBottom = "0px";

    collapseLegend?.addEventListener("click", () => {
        collapse?.classList?.toggle("hide-collapse");
        collapseLegend.classList.toggle("plus-icon");
        collapseLegend.classList.toggle("minus-icon");
    });
})(window, document);